// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c3a899c","298":"a834de23","683":"01852588","728":"421b0369","935":"13d00beb"}[chunkId] + ".chunk.js";
};